export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5424.27099d17.jpg";